import { UserGroupIcon, UserPlusIcon, PhoneIcon, CheckBadgeIcon, ArrowTrendingUpIcon } from '@heroicons/react/24/outline'

const STAT_CARDS = [
  { key: 'total', label: 'Total Leads', icon: UserGroupIcon, color: 'slate', filterValue: 'all' },
  { key: 'new', label: 'New', icon: UserPlusIcon, color: 'blue', filterValue: 'new' },
  { key: 'contacted', label: 'Contacted', icon: PhoneIcon, color: 'amber', filterValue: 'contacted' },
  { key: 'qualified', label: 'Qualified', icon: CheckBadgeIcon, color: 'purple', filterValue: 'qualified' },
  { key: 'converted', label: 'Converted', icon: ArrowTrendingUpIcon, color: 'green', filterValue: 'converted' },
]

const COLOR_MAP = {
  slate: 'bg-slate-50 text-slate-600 border-slate-200',
  blue: 'bg-blue-50 text-blue-600 border-blue-200',
  amber: 'bg-amber-50 text-amber-600 border-amber-200',
  purple: 'bg-purple-50 text-purple-600 border-purple-200',
  green: 'bg-green-50 text-green-600 border-green-200',
}

const ICON_COLOR_MAP = {
  slate: 'bg-slate-100 text-slate-500',
  blue: 'bg-blue-100 text-blue-500',
  amber: 'bg-amber-100 text-amber-500',
  purple: 'bg-purple-100 text-purple-500',
  green: 'bg-green-100 text-green-500',
}

export default function LeadStats({ stats, activeFilter, onFilterClick }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
      {STAT_CARDS.map(({ key, label, icon: Icon, color, filterValue }) => {
        const value = key === 'total' ? stats.total : (stats.by_status?.[key] || 0)
        const isActive = activeFilter === filterValue
        return (
          <button
            key={key}
            onClick={() => onFilterClick(filterValue)}
            className={`rounded-xl border p-4 text-left transition-all hover:shadow-sm ${
              isActive ? `${COLOR_MAP[color]} ring-2 ring-offset-1 ring-${color}-400` : 'bg-white border-slate-200 hover:border-slate-300'
            }`}
          >
            <div className="flex items-center justify-between mb-2">
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${ICON_COLOR_MAP[color]}`}>
                <Icon className="h-4 w-4" />
              </div>
            </div>
            <div className="text-2xl font-bold text-slate-900">{value}</div>
            <div className="text-xs text-slate-500 mt-0.5">{label}</div>
          </button>
        )
      })}
    </div>
  )
}
